// extracted by mini-css-extract-plugin
module.exports = {"modalButton":"FreeTextAnswerModal_modalButton__3s0JX","chagedTextIcon":"FreeTextAnswerModal_chagedTextIcon__2sBCf","modalButtonIcon":"FreeTextAnswerModal_modalButtonIcon__3-juK"};